// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1D-X1","range":"MonthRangeSwitch_range__3z7l0","disabled":"MonthRangeSwitch_disabled__3fplx"};